import { render, staticRenderFns } from "./mktTagList.vue?vue&type=template&id=9ecf939a&"
import script from "./mktTagList.vue?vue&type=script&lang=js&"
export * from "./mktTagList.vue?vue&type=script&lang=js&"
import style0 from "./mktTagList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports